import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PhoneButtonTemplateFieldConfig, PhoneButtonTemplateFieldConfigRequest } from '../models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class PhoneButtonTemplateFieldConfigResource {
  protected http = inject(HttpClient);

  protected _baseUrl = '/services/cisco/field-configs/phone-button-templates';

  post(body: PhoneButtonTemplateFieldConfigRequest): Observable<PhoneButtonTemplateFieldConfig> {
    return this.http.post<PhoneButtonTemplateFieldConfig>(this._baseUrl, body);
  }
}
